<template>
  <div class="layout-tabbar">
    <div class="tabbar">
      <div
        v-for="tab in footerTabbar"
        :key="`168-footer-tabbar-${tab.label}`"
        :class="{'tabbar__item--active': activeTab(tab).class}"
        class="tabbar__item"
        @click="() => handleClick(tab)"
      >
        <div class="tabbar__item__icon">
          <img
            :src="activeTab(tab).src"
            alt="找不到图片！"
          >
        </div>
        <span>{{ tab.label }}</span>
      </div>
    </div>
    <NewspaperPopUpContent
      :show.sync="showAllLottery"
    />
  </div>
</template>

<script>
import NewspaperPopUpContent from '@/components/mobile/layout/NewspaperPopupContent'

export default {
  name: 'WapFooter',
  components: {
    NewspaperPopUpContent
  },
  data() {
    return {
      footerTabbar: [
        {
          href: '/m',
          iconSrc: require('@/assets/style/img/tabbar/icon-img1@2x.png'),
          iconActiveSrc: require('@/assets/style/img/tabbar/icon-img1-Active@2x.png'),
          label: '首页',
          // children: [],
          subType: ''
        },
        {
          href: '/m/lottery/group/hotLottery',
          iconSrc: require('@/assets/style/img/tabbar/iconLottery@2x.png'),
          iconActiveSrc: require('@/assets/style/img/tabbar/iconLottery-Active@2x.png'),
          label: '彩种'
        },
        {
          href: '/m/images',
          iconSrc: require('@/assets/style/img/tabbar/icon-img@2x.png'),
          iconActiveSrc: require('@/assets/style/img/tabbar/icon-img-Active@2x.png'),
          label: '图库'
        },
        {
          href: '/m/lotterybet/lotteryhome/jspk10/rank',
          iconSrc: require('@/assets/style/img/tabbar/iconBuy@2x.png'),
          iconActiveSrc: require('@/assets/style/img/tabbar/iconBuy-Active@2x.png'),
          label: '竞猜'
        },
        {
          href: '/m/member',
          iconSrc: require('@/assets/style/img/tabbar/iconCustomerService@2x.png'),
          iconActiveSrc: require('@/assets/style/img/tabbar/iconCustomerService-Active@2x.png'),
          label: '我的'
        }
      ],
      showAllLottery: false

    }
  },
  methods: {
    activeTab(tab) {
      const routePath = this.$route.path
      switch (tab.href) {
        case '/m/lottery/group/hotLottery':
          if (/^\/m\/lottery\/group/.test(routePath)) {
            return {
              class: true,
              src: tab.iconActiveSrc
            }
          } else {
            return {
              class: false,
              src: tab.iconSrc
            }
          }
        case '/m/member':
          if (/^\/m\/member/.test(routePath)) {
            return {
              class: true,
              src: tab.iconActiveSrc
            }
          } else {
            return {
              class: false,
              src: tab.iconSrc
            }
          }
        case '/m':
        default:
          if (routePath === tab.href || routePath === `${tab.href}/`) {
            return {
              class: true,
              src: tab.iconActiveSrc
            }
          } else {
            return {
              class: false,
              src: tab.iconSrc
            }
          }
      }
    },
    handleClick(tab) {
      if (tab.href === '/m/images') {
        this.openAllLotteryPopUp()
      } else {
        window.location.href = tab.href
      }
    },
    openAllLotteryPopUp() {
      this.showAllLottery = true
    }
  }
}
</script>

<style lang="scss" scoped>

  .subitem__wrapper {
    position: absolute;
    top: -60px;
  }

  .tabbar__subitem {
    width: 100px;
    border: 1px solid #d8d8d8;
    background: #ebe9e9;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;

    span {
      color: #161616;
    }
  }
</style>
